import {
  AlleLeistungsarten,
  OeffentlicheAuftraggeber,
  PrivateAuftraggeber,
} from "components/page-components/Icons/large"

import { CreateGrooveRecallModal } from "components/page-components/Groove"
import { ExpandableCard } from "components/page-components/Info-Modules"
import { Link } from "gatsby"
import React from "react"
import { useGrooveRecallModalState } from "components/page-components/Groove/utils"

export const LpUnserAngebot = () => {
  const { recallModal, toggleRecallModal } = useGrooveRecallModalState()

  return (
    <React.Fragment>
      <div className="section has-background-mitternachtsblau-5">
        <div className="container">
          <p className="title is-3 has-text-mitternachtsblau has-text-centered">
            Unser Angebot
          </p>
          <div className="columns is-centered my-6">
            <div className="column is-8">
              <div className="columns is-centered mb-6">
                <div
                  className="column has-text-centered is-one-third is-flex is-flex-direction-column is-justify-content-space-between"
                  style={{ height: 180 }}
                >
                  <p>
                    <OeffentlicheAuftraggeber />
                  </p>
                  <p className="has-text-weight-bold has-text-mitternachtsblau">
                    Ausschreibungen von <br />
                    Öffentlichen Anbietern
                  </p>
                </div>
                <div
                  className="column has-text-centered is-one-third is-flex is-flex-direction-column is-justify-content-space-between"
                  style={{ height: 180 }}
                >
                  <p>
                    <PrivateAuftraggeber />
                  </p>
                  <p className="has-text-weight-bold has-text-mitternachtsblau">
                    Aufträge von privaten und <br />
                    gewerblichen Anbietern
                  </p>
                </div>
                <div
                  className="column has-text-centered is-one-third is-flex is-flex-direction-column is-justify-content-space-between"
                  style={{ height: 180 }}
                >
                  <p>
                    <AlleLeistungsarten />
                  </p>
                  <p className="has-text-weight-bold has-text-mitternachtsblau">
                    Alle Leistungsarten: <br />
                    Bau-, Liefer-, Dienstleistungen
                  </p>
                </div>
              </div>
            </div>
          </div>

          <p className="title is-3 has-text-centered my-6 has-text-mitternachtsblau">
            Sie haben noch Fragen?
          </p>

          <ExpandableCard
            title="Sie möchten nur ganz bestimmte Aufträge finden?"
            open_by_default
          >
            <p>
              Zum Beispiel Dienstleistungen im Bereich UVgO in der Stadt
              Potsdam? Unsere Filterfunktionen unterstützen Sie bei der
              Auftragssuche. Bei Fragen zum Vergabemanagement und zum
              Ausschreibungsverfahren wenden Sie sich gerne telefonisch oder per{" "}
              <a href="mailto:service@bi-medien.de">
                E-Mail an unseren Kundenservice
              </a>
              .
            </p>
          </ExpandableCard>

          <ExpandableCard title="Welche Arten von Ausschreibungen bietet B_I ausschreibungsdienste?">
            <p>
              Wir veröffentlichen nationale und EU-weite Ausschreibungen aus
              ganz Deutschland für alle Leistungsarten: Bauleistungen,
              Dienstleistungen und Lieferleistungen. Darüber hinaus
              veröffentlichen wir Informationen zu Bauvorhaben von privaten und
              gewerblichen Bauherren.
            </p>
          </ExpandableCard>

          <ExpandableCard title="Für welche Firmen sind Öffentliche Ausschreibungen geeignet?">
            <p>
              In der Regel können bereits kleine Betriebe Aufträge der
              Öffentlichen Hand als Auftragsquelle nutzen. Die genaue
              Beurteilung hängt allerdings von der Branche des Unternehmens ab:
              Während es bei z.B. bei spezialisierten Lieferleistungen oder
              Dienstleistungen viele Aufträge für Kleinstunternehmen gibt,
              stellen öffentliche Aufträge in anderen Branchen höhere
              Anforderungen an die Betriebsgröße. Kleinen Betrieben kommt die
              Aufteilung von Ausschreibungen in Fach- und Teillose zugute. Wir
              beraten Sie gerne zu der Frage, ob Ihr Unternehmen von
              Öffentlichen Ausschreibungen profitieren kann.
            </p>
          </ExpandableCard>

          <div className="buttons is-centered my-6 pb-6">
            <button
              onClick={toggleRecallModal}
              className="button is-mitternachtsblau is-outlined has-text-weight-bold"
            >
              Beratung vereinbaren
            </button>
          </div>
          <div className="section has-background-mitternachtsblau my-6">
            <div className="p-4">
              <p className="title is-3 is-spaced has-text-centered has-text-white">
                Hier erfahren Sie mehr über Vergaberecht und e-Vergabe
              </p>
              <p className="has-text-centered has-text-white">
                Aktuelle Beiträge und Nachrichten zum Vergaberecht, ein
                umfangreiches Lexikon über Begriffe aus der Vergabe und vieles
                mehr erwartet Sie in unserem Wissens-Bereich.
              </p>
              <div className="has-text-centered mt-6">
                <Link
                  className="button is-white is-outlined "
                  to={"/vergabe-wissen"}
                >
                  Zum Wissens-Bereich
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <CreateGrooveRecallModal
        {...{
          recallModal,
          toggleRecallModal,
          segment: "ausschreibungsdienste",
        }}
      />
    </React.Fragment>
  )
}
